
export default {
  name: 'AppPlayIcon'
};
